import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import PaymentIcon from "@material-ui/icons/Payment";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import Button from "../../../../components/elements/Button";
import classes from "./NoBillingLogs.module.scss";

type NoBillingLogsProps = {
  handleBack: () => void;
};

const NoBillingLogs: FC<NoBillingLogsProps> = ({ handleBack }) => {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <PaymentIcon className={classes.icon} />

        <div>
          <Typography variant="h2">No Billing Logs</Typography>
          <Typography>Run Compaigns to view billing logs.</Typography>
          <Button variant="contained" onClick={handleBack}>
            <ArrowBackIosIcon /> Account Information
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoBillingLogs;
